import { useEffect, useState } from "react";
import { FileText, Download, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, money, fmtDate, formatApiError } from "@/lib/api";

export async function openDocument(docId: string) {
  const { data } = await api.get(`/documents/${docId}/download`, { responseType: "blob" });
  window.open(URL.createObjectURL(data), "_blank", "noopener");
}

export function Documents({ series }: { series: any[] }) {
  const [docs, setDocs] = useState<any[]>([]);
  const [busy, setBusy] = useState("");
  const load = () => api.get("/documents").then((r) => setDocs(r.data));
  useEffect(() => { load(); }, []);

  const invoice = async (s: any) => {
    setBusy(s.series_id);
    try { const { data } = await api.get(`/series/${s.series_id}/invoice`, { params: { month: new Date().toISOString().slice(0, 7) } }); await load(); await openDocument(data.doc_id); }
    catch (err) { toast.error(formatApiError(err)); } finally { setBusy(""); }
  };

  return (
    <section className="mt-8" data-testid="documents-section">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <h3 className="font-heading text-lg font-semibold text-brand-navy">Receipts & invoices</h3>
        {series.map((s) => <button key={s.series_id} onClick={() => invoice(s)} disabled={!!busy} className="inline-flex items-center gap-2 rounded-full border border-brand-line bg-white px-4 py-1.5 text-xs font-semibold text-brand-navy hover:bg-slate-50 disabled:opacity-50" data-testid="generate-invoice-button">{busy === s.series_id ? <Loader2 className="h-3 w-3 animate-spin" /> : <FileText className="h-3 w-3" />}This month's invoice · {s.service_name}</button>)}
      </div>
      {docs.length === 0 ? <p className="mt-3 text-sm text-brand-slate" data-testid="documents-empty">Receipts are emailed and listed here after each payment.</p> : (
        <ul className="mt-3 divide-y divide-brand-line rounded-2xl border border-brand-line bg-white">
          {docs.map((d) => (
            <li key={d.doc_id} className="flex items-center justify-between gap-3 px-5 py-3 text-sm" data-testid="document-row">
              <div className="flex items-center gap-3"><FileText className={`h-5 w-5 ${d.kind === "invoice" ? "text-brand-blue" : "text-brand-emerald"}`} /><div><p className="font-medium text-brand-navy">{d.title}</p><p className="text-xs text-brand-slate">{fmtDate(d.created_at)}{d.amount != null ? ` · ${money(d.amount, d.currency)}` : ""}{d.email_status === "sent" ? " · emailed" : ""}</p></div></div>
              <button onClick={() => openDocument(d.doc_id)} className="inline-flex items-center gap-1 rounded-full bg-brand-navy px-3 py-1.5 text-xs font-semibold text-white" data-testid="download-document-button"><Download className="h-3 w-3" />PDF</button>
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}
